import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";


const ErrorContainer = styled.div`
  width:100%;
  background-color: #ffffff;
  padding:20px;
  border:1px solid #eee;
  border-left-width:5px;
  border-radius: 3px;
  margin:10px auto;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;

  border-left-color: #d9534f; /* Left side border color */
  background-color: rgba(217, 83, 79, 0.1); /*Same color as the left border with reduced alpha to 0.1*/
`;

function ErrorMessage({errorMsg}) {
    return (
        <ErrorContainer>
            {errorMsg}
        </ErrorContainer>
    );
}

ErrorMessage.propTypes = {};
ErrorMessage.defaultProps = {};

export default ErrorMessage;
